import { css } from 'jimu-core';
export const tableStyles = (props) => {
    var _a;
    const theme = props.theme;
    const tableVariables = (_a = theme === null || theme === void 0 ? void 0 : theme.components) === null || _a === void 0 ? void 0 : _a.table;
    return tableVariables && css `
    width: 100%;
    margin-bottom: 1rem;
    color: ${tableVariables.color};
    background-color: ${tableVariables.bg};

    th,
    td {
      padding: ${tableVariables.cell.default.paddingY} ${tableVariables.cell.default.paddingX};
      vertical-align: top;
      border-top: ${tableVariables.border.width} solid ${tableVariables.border.color};
    }

    thead th {
      font-size: ${tableVariables.head.fontSize};
      background: ${tableVariables.head.bg};
      vertical-align: bottom;
      border-bottom: ${tableVariables.border.width} solid ${tableVariables.border.color};
    }

    tbody + tbody {
      border-top: ${tableVariables.border.width} solid ${tableVariables.border.color};
    }

    &.table-sm {
      th,
      td {
        padding: ${tableVariables.cell.sm.paddingY} ${tableVariables.cell.sm.paddingX};
      }
    }

    /* Border versions */
    &.table-bordered {
      border: ${tableVariables.border.width} solid ${tableVariables.border.color};
      th,
      td {
        border: ${tableVariables.border.width} solid ${tableVariables.border.color};
      }
    }

    &.table-borderless {
      th,
      td,
      thead th,
      tbody + tbody {
        border: 0;
      }
    }

    /* Zebra-striping */
    &.table-striped {
      tbody tr:nth-of-type(even) {
        background-color: ${tableVariables.variants.striped.bg};
      }
    }

    /* Dark styles */
    &.table-dark {
      color: ${tableVariables.variants.dark.color};
      background-color: ${tableVariables.variants.dark.bg};
      th {
        color: $table-dark-color;
        background-color: $table-dark-bg;
        border-color: $table-dark-border-color;
      }
      th,
      td {
        border-top-color: ${tableVariables.variants.dark.border.color};
      }

      thead th {
        background: ${tableVariables.variants.dark.head.bg};
        border-bottom-color: ${tableVariables.variants.dark.border.color};
      }

      tbody + tbody {
        border-top-color: ${tableVariables.variants.dark.border.color};
      }
    }
  `;
};
